<template>
    <div class="content_wrap">
        <div class="wrap">
            <div class="password_main risk-content">
                <div class="password_main_top ft24">
                    <span class="second_font">风险生成</span>
                </div>
                <div class="risk-main">
                    <a-alert style="margin-bottom: 16px;" message="注意：修改发票内容后，请点击 √ 保存本次修改再提交！" type="warning" show-icon />
                    <a-button class="editable-add-btn" type="primary" @click="handleAdd">
                        新增 +
                    </a-button>
                    <a-table @change="pageOnChange" :locale="{ emptyText: '暂无数据' }" bordered :data-source="dataSource"
                        :columns="columns">
                        <template slot="invoiceNumber" slot-scope="text, record">
                            <editable-cell :isSelect="false" :text="text.toString()"
                                @change="onCellChange(record.key, 'invoiceNumber', $event)" />
                        </template>

                        <template slot="invoiceCode" slot-scope="text, record">
                            <editable-cell :isSelect="false" :text="text.toString()"
                                @change="onCellChange(record.key, 'invoiceCode', $event)" />
                        </template>

                        <template slot="riskType" slot-scope="text, record">
                            <editable-cell :isSelect="true" :text="text.toString()"
                                @change="onCellChange(record.key, 'riskType', $event)" />
                        </template>

                        <template slot="operation" slot-scope="text, record">
                            <a-popconfirm v-if="dataSource.length" title="确定删除吗？" cancelText="取消" okText="确定"
                                @confirm="() => onDelete(record.key)">
                                <a href="javascript:;">删除</a>
                            </a-popconfirm>
                        </template>
                    </a-table>

                    <div class="risk-content-footer">
                        <a-button @click="handleCancel" class="mr10">
                            取消
                        </a-button>
                        <a-button type="primary" @click="handleSubmit">
                            确定
                        </a-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
const EditableCell = {
    template: `
        <div class="editable-cell">
          <div v-if="editable" class="editable-cell-input-wrapper">
            <a-select style="width: 100px" :value="value" @change="handleChange" @pressEnter="check"
                v-if="isSelect">
                <a-select-option v-for="item in selectArr"
                    :key="item" :value="item">
                    {{ item }}
                </a-select-option>
            </a-select>
            <a-input v-else :value="value" @change="handleChange" @pressEnter="check" />
            <a-icon
              type="check"
              class="editable-cell-icon-check"
              @click="check"
            />
          </div>
          <div v-else class="editable-cell-text-wrapper">
            {{ value || ' ' }}
            <a-icon type="edit" class="editable-cell-icon" @click="edit" />
          </div>
        </div>
      `,
    props: {
        text: String,
        isSelect: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            value: this.text,
            editable: false,
            selectArr: ["作废", "重复核验", "重复监控", "红冲", "失控", "异常", "部分红冲", "全额红冲"]
        };
    },
    methods: {
        handleChange(e) {
            let value = this.isSelect ? e : e.target.value;
            value = value && value.trim()
            this.value = value;
        },
        check() {
            this.editable = false;
            this.$emit('change', this.value);
        },
        edit() {
            this.editable = true;
        },

    },
};
export default {
    components: {
        EditableCell,
    },
    data() {
        return {
            dataSource: [],
            count: 0,
            columns: [
                {
                    title: '发票号码',
                    dataIndex: 'invoiceNumber',
                    width: '250px',
                    scopedSlots: { customRender: 'invoiceNumber' },
                },
                {
                    title: '发票代码',
                    dataIndex: 'invoiceCode',
                    width: '250px',
                    scopedSlots: { customRender: 'invoiceCode' },
                },
                {
                    title: '风险类型',
                    dataIndex: 'riskType',
                    width: '150px',
                    scopedSlots: { customRender: 'riskType' },
                },
                {
                    title: '操作',
                    dataIndex: 'operation',
                    width: '100px',
                    scopedSlots: { customRender: 'operation' },
                },
            ],
        };
    },
    methods: {
        onCellChange(key, dataIndex, value) {
            const dataSource = [...this.dataSource];
            const target = dataSource.find(item => item.key === key);
            if (target) {
                target[dataIndex] = value;
                this.dataSource = dataSource;
            }
        },
        onDelete(key) {
            const dataSource = [...this.dataSource];
            this.dataSource = dataSource.filter(item => item.key !== key);
        },
        handleAdd() {
            const { count, dataSource } = this;
            const newData = {
                key: count,
                invoiceNumber: ``,
                invoiceCode: '',
                riskType: ''
            };
            this.dataSource = [...dataSource, newData];
            this.count = count + 1;
        },
        handleCancel() {
            this.$router.push('/developCenter/invoiceCheck')
        },
        handleSubmit() {
            if (!this.dataSource.length) return this.$message.warning('请先新增风险详情后进行提交');
            const riskEnum = {
                "作废": "0",
                "重复核验": "1",
                "重复监控": "2",
                "红冲": "5",
                "失控": "6",
                "异常": "7",
                "部分红冲": "5",
                "全额红冲": "5"
            }
            let params = {
                "list": this.dataSource.map(item => {
                    return {
                        invoiceCode: item.invoiceCode,
                        invoiceNumber: item.invoiceNumber,
                        riskType: riskEnum[item.riskType],
                        riskTypeName: item.riskType
                    }
                })
            }
            this.http.post('/ystOpenPlatformBff/invoice/check/util/mockRisk', params, res => {
                if (res.success) {
                    this.$message.success('操作成功！')
                    this.dataSource = []
                } else {
                    this.$message.warning(res.message)
                }
            })
        },
        pageOnChange(page) {
            console.log(page);
        },
    },
};
</script>
<style lang="scss">
.editable-cell {
    position: relative;
}

.editable-cell-input-wrapper,
.editable-cell-text-wrapper {
    padding-right: 24px;
}

.editable-cell-text-wrapper {
    padding: 5px 24px 5px 5px;
}

.editable-cell-icon,
.editable-cell-icon-check {
    position: absolute;
    right: 0;
    width: 20px;
    cursor: pointer;
}

.editable-cell-icon {
    line-height: 18px;
    display: none;
}

.editable-cell-icon-check {
    line-height: 28px;
}

.editable-cell:hover .editable-cell-icon {
    display: inline-block;
}

.editable-cell-icon:hover,
.editable-cell-icon-check:hover {
    color: #108ee9;
}

.editable-add-btn {
    margin-bottom: 8px;
}

.risk-content.password_main {
    width: 800px;

    .risk-content-footer {
        margin-top: 15px;
        text-align: right;
    }

    .risk-main {
        padding: 15px;
    }
}
</style>



// WEBPACK FOOTER //
// src/page/Risk.vue